import { useGlobalContext } from "./context/globalContext";
import React, { useState, useRef, useEffect } from "react";
// import {
//   FaSchool,
//     FaFilm,
//   FaShoppingCart,
//     FaUtensils,
//   FaHospitalSymbol,
// } from "react-icons/fa";
import { FaMapLocation, FaHotel } from "react-icons/fa6";
import { FaShoppingCart } from "react-icons/fa";
import { IoSchool } from "react-icons/io5";
import { MdHealthAndSafety } from "react-icons/md";

const LocationBenefits2 = ({ project }) => {
  const { handleShowModal } = useGlobalContext();
  const [activeDetail, setActiveDetail] = useState(null);
  const detailsRef = useRef(null);

  // Handle click outside to close details
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if click is outside both the details and the icon
      if (
        detailsRef.current &&
        !detailsRef.current.contains(event.target) &&
        !event.target.closest(".benefit-icon")
      ) {
        setActiveDetail(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Handle icon click
  const handleIconClick = (index, event) => {
    event.stopPropagation();
    setActiveDetail(activeDetail === index ? null : index);
  };
  const benefits = [
    {
      icon: <IoSchool />,
      title: "Education",
      details: [
        "JCBN international School – 1.2 Km",
        "Don Bosco High School – 1 Km",
        "Ruia College – 2 Km",
      ],
    },
    {
      icon: <MdHealthAndSafety />,
      title: "Hospitals",
      details: [
        "KEM Hospital – 1.5 Km",
        "TATA Memorial Hospital – 1.8 Km",
        "Global Hospital – 1.7 Km",
      ],
    },
    {
      icon: <FaMapLocation />,
      title: "Connectivity",
      details: [
        "Sewri Railway Station – 0.3 Km",
        "CSTM Railway Station – 8.3 Km",
        "Proposed Metro Station – 2.7 Km",
        "CSIA Airport – 17.4 Km",
      ],
    },
    {
      icon: <FaShoppingCart />,
      title: "Malls",
      details: [
        "Palladium – 5.5 Km",
        "Phoenix Market City – 13 Km",
        "Atria Mall – 7 Km",
        "CR2 – 10.5 Km",
      ],
    },
    {
      icon: <FaHotel />,
      title: "5 Star Hotels",
      details: [
        "ITC Grand Central – 2 Km",
        "The St. Regis – 4 Km",
        "Four Seasons – 5 Km",
        "The Taj Mahal Palace – 9.7 Km",
      ],
    },
  ];
  return (
    <>
      <div className="section shadow-sm lazyloaded">
        <div className="lb-container">
          <div className="lb-map">
            <img src="/images/lb.webp" alt="Location Overview" />
          </div>
          <div className="lb-content">
            <div className="lb-content-body">
              <h2 className="head text-capitalize text-center">
                {project} - Location & Connectivity
              </h2>
              <div className="cards">
                {benefits.map((benefit, index) => (
                  <div
                    key={index}
                    className={`crd position-${index + 1}  ${
                      activeDetail === index ? "alive-card" : ""
                    } `}
                  >
                    <div
                      className="crd-icon"
                      onClick={(e) => handleIconClick(index, e)}
                    >
                      {benefit.icon}
                      <span className="crd-title">{benefit.title}</span>
                    </div>
                    <div
                      ref={activeDetail === index ? detailsRef : null}
                      className={`crd-details ${
                        activeDetail === index ? "active" : ""
                      }`}
                      id="card-details-scroll"
                    >
                      <ul>
                        {/* {benefit.details.map((detail, idx) => (
                          <li key={idx}>{detail}</li>
                        ))} */}
                        {benefit.details.map((detail, idx) => {
                          const parts = detail.split(" – "); // Using " – " (en dash) for separation
                          if (parts.length === 2) {
                            return (
                              <li key={idx}>
                                <span>{parts[0]}</span>
                                <span>{parts[1]}</span>
                              </li>
                            );
                          } else {
                            return <li key={idx}>{detail}</li>; // Handle cases with no " – "
                          }
                        })}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="lb-content-footer">
              <span className="new-button " onClick={handleShowModal}>
                <span className="new-button-inner">
                  <span className="underline-animation">Get All Details</span>
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default LocationBenefits2;
